// extracted by mini-css-extract-plugin
module.exports = {"bg":"_1_q7z","inlineContent":"_3kl4J","pageWrapper":"_2_0WD","shd":"_2WDPN","left":"_3MJsx","right":"jy9zd","innerBg":"_1aHe7"};